export default "__VITE_ASSET__66451163__"